import api from "./index";
import { categoryApi } from "./index";

export interface CategoriesListParams {
  companyId: string;
  title?: string;
  categoryIds?: Array<string>;
  parentId?: string;
  userId?: string;
  studentId?: string;
  entities?: Array<"courseV1" | "courseV2" | "webinar" | "video">;
  offset?: number;
  limit?: number;
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: CategoriesListParams, options?: any) => {
  return categoryApi.category.listCategory(
    params.companyId,
    params.title,
    params.categoryIds,
    params.parentId,
    params.userId,
    params.studentId,
    params.entities,
    params.offset,
    params.limit,
    options
  );
};
